"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextSection = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var TextSection = function (_a) {
    var section = _a.section;
    return ((0, jsx_runtime_1.jsx)("section", { className: "py-16 px-6", children: (0, jsx_runtime_1.jsxs)("div", { className: "max-w-4xl mx-auto", children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-3xl md:text-4xl font-bold text-center mb-8", children: section.title }), (0, jsx_runtime_1.jsx)("div", { className: "text-lg text-gray-700 leading-relaxed text-center", children: section.content })] }) }));
};
exports.TextSection = TextSection;
